import React from "react";
import Icon from "../../Icon/Icon";
import styles from "./FactsComparisonCard.module.sass";
import { BarChart } from "../../charts";
const FactsComparisonCard = props => {
  const {
    title,
    data,
    dataLabels,
    currency,
    links,
    icon
  } = props || {};
  return /*#__PURE__*/React.createElement("div", {
    className: styles["root"]
  }, /*#__PURE__*/React.createElement("h5", {
    className: `widget-title ${styles["title"]}`
  }, /*#__PURE__*/React.createElement("div", null, icon && /*#__PURE__*/React.createElement(Icon, {
    className: styles["icon"],
    name: icon
  }), /*#__PURE__*/React.createElement("div", null, title))), /*#__PURE__*/React.createElement("div", {
    className: styles["chart"]
  }, /*#__PURE__*/React.createElement("div", null, data && /*#__PURE__*/React.createElement(BarChart, {
    data: data,
    dataLabels: dataLabels,
    links: links,
    currency: currency
  }))));
};
export default FactsComparisonCard;